import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function TractionSection() {
  return <Section background="ivory" className="border-y border-purple-200 bg-purple-50" data-id="element-312">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-313">
        <div data-id="element-314">
          <FadeIn data-id="element-315">
            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-316">
              Early Validation, <br data-id="element-317" />
              <span className="italic text-charcoal/60" data-id="element-318">Strong Signal</span>
            </h2>
            <p className="text-lg text-charcoal/70 mb-8" data-id="element-319">
              Early-stage, but highly validated with strong ecosystem pull. The
              market is ready for a new standard of care.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-8" data-id="element-320">
          <FadeIn delay={100} data-id="element-321">
            <div className="bg-ivory/50 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-white/50" data-id="element-322">
              <div className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-323">
                $37K
              </div>
              <div className="text-sm text-charcoal/60 font-medium" data-id="element-324">
                Non-dilutive funding
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={200} data-id="element-325">
            <div className="bg-ivory/50 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-white/50" data-id="element-326">
              <div className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-327">
                20+
              </div>
              <div className="text-sm text-charcoal/60 font-medium" data-id="element-328">
                Practitioners onboarded
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={300} data-id="element-329">
            <div className="bg-ivory/50 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-white/50" data-id="element-330">
              <div className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-331">
                250+
              </div>
              <div className="text-sm text-charcoal/60 font-medium" data-id="element-332">
                Waitlist users
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={400} data-id="element-333">
            <div className="bg-ivory/50 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-white/50" data-id="element-334">
              <div className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-335">
                50+
              </div>
              <div className="text-sm text-charcoal/60 font-medium" data-id="element-336">
                Engaged early members
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </Section>;
}